export default {
    error: {
        generic:
            "This segment stopped updating. Contact support if the problem persists.",
        points_program_inactive:
            "This segment stopped updating because it uses points balance as a condition, and the points program is disabled. Re-enable the program or remove that condition to resume updates.",
        short: {
            generic: "Updates paused.",
            points_program_inactive: "Updates paused: points program disabled.",
        },
    },
    create_modal: {
        title: "Create Segment",
        label: "Please enter the segment name",
        loading: "Creating segment, this may take a few moments...",
        cancel: "Cancel",
        create: "Create",
        trigger: "Create Segment",
        success: "Segment created successfully!",
        internal_error: "Internal server error, please try again later!",
    },
    list: {
        delete_title: "Do you want to delete this segment?",
        delete_body:
            "This action is irreversible and will permanently delete this segment and all related data.",
        title: "Customer segments",
        add_button: "Add",
        add_aria: "Add segment",
        search_placeholder: "Search segment by name...",
        search_aria: "Search segment by name",
        max_reached_prefix: "You have reached the maximum of",
        max_reached_suffix: "forms",
        segment_contacts_tooltip: "View contacts in this segment",
        last_30_days: "Movements in the last 30 days",
        joined: "Joined:",
        left: "Left:",
        clients: "clients",
        edit: "Edit",
        delete: "Delete",
        edit_segment_aria: "Edit segment {0}",
        delete_segment_aria: "Delete segment {0}",
        deleted_success: "Segment deleted",
        delete_in_use_by_tier: "This segment is used by the {name} tier. To delete it, delete the tier first in the Benefits Center.",
        delete_error: "Could not delete the segment.",
        manual_badge: "Manual",
        dynamic_badge: "Dynamic",
        manage_members: "Manage members",
        manage_members_aria: "Manage members of segment {0}",
        add_members: "Add members",
        remove_members: "Remove members",
        columns_name: "Name",
        columns_type: "Type",
        columns_clients: "Clients",
        columns_movements: "Movements",
        columns_actions: "Actions",
        columns_created_at: "Created at",
        filters_type: "Type",
        filters_created_period: "Creation date",
    },
    members: {
        modal_add_title: "Add members to segment",
        modal_remove_title: "Remove members from segment",
        title: "Manage segment members",
        back: "Back to segments",
        add_button: "Add matching clients",
        remove_button: "Remove matching clients",
        confirm_add_title: "Add clients to segment?",
        confirm_add_body: "This will add {0} matching clients to this segment.",
        confirm_remove_title: "Remove clients from segment?",
        confirm_remove_body: "This will remove {0} matching clients from this segment.",
        add_success: "{0} clients added ({1} already in segment).",
        remove_success: "{0} clients removed ({1} were not in segment).",
        saving_add: "Adding clients to segment...",
        saving_remove: "Removing clients from segment...",
        saving_hint: "This may take a moment for large audiences.",
        dynamic_error: "Only manual segments support membership management.",
        error: "Could not update segment membership.",
    },
    form: {
        add_title: "Add segment",
        name_helper: "Choose a name to identify your segment",
        name_placeholder: "Segment name",
        update_daily: "Update daily?",
        type_help: "Dynamic segments recalculate membership daily. Manual segments keep a fixed list of clients.",
        manual_populate_label: "How should this manual segment start?",
        start_empty: "Start empty",
        populate_from_filters: "Populate from filters",
        yes: "Yes",
        no: "No",
        audience: "Audience:",
        ai_placeholder:
            "Who has not purchased for 90 days and has two or more purchases",
        ai_filter: "Filter",
        ai_use: "Use AI",
        ai_error_prefix:
            "Could not generate exact filters for this description.",
        ai_error_hint: "You may want:",
        loading_sentences: {
            s1: "Analyzing available filters...",
            s2: "Identifying the best criteria...",
            s3: "Processing customer data...",
            s4: "Selecting segmentation algorithms...",
            s5: "Refining parameters...",
            s6: "Still processing, this may take a while...",
            s7: "Your patience will pay off...",
            s8: "Finishing the last details...",
            s9: "Seriously, almost done...",
            s10: "Just one more minute...",
            s11: "Don't give up, we are almost there...",
        },
        empty_state: "Add filters or groups to create your condition",
        calculating_target: "Calculating target audience...",
        save: "Save",
        updating: "Updating...",
        creating: "Creating...",
        filters_generated_success: "Filters generated successfully!",
        filters_generated_error: "Error generating filters. Try again.",
        server_error_prefix: "Error communicating with the server:",
        save_error_log: "Error saving segment:",
        invalid_filters_log: "Invalid filters received:",
    },
    filters: {
        orders_count: "Number of orders",
        quotations_count: "Number of quotations",
        quotations_amount: "Quotation amount",
        rfm_group: "RFM group",
        campaign_interactions: "Campaign interactions",
        days_after_field: "Days after {0}",
        custom_event: "Custom event",
        purchased_product: "Purchased product",
        filled_form: "Filled a form",
        customer_profile: "Customer profile",
        profile_complete: "With complete profile",
        profile_incomplete: "Without complete profile",
        profile_with_phone: "With phone",
        profile_with_email: "With email",
        points_balance: "Points balance",
        average_ticket: "Average ticket",
        clv_total_spent: "Accumulated spend (CLV)",
        branches: "Branches",
        days_since_last_order: "Days since last order",
        days_since_first_order: "Days since first order",
        days_until_next_order: "Predicted days until next order",
        days_since_created: "Days since signup",
        age: "Age",
        birthday_month: "Birthdays of the month",
        communication_channels: "Communication channels",
        accepted: "Accepted",
        and: "and",
        between: "between",
        birthdays_of_month: "Birthdays of the month",
        close: "Close",
        conditions_count: "{count} question condition(s)",
        days_ago: "days ago",
        event: "Event",
        form: "Form",
        no_questions: "This form has no questions to filter by.",
        question_conditions: "Question responses (optional)",
        select_form: "Select a form",
        which_form: "Which form",
        executions: "Executions",
        from: "from",
        indifferent: "Indifferent",
        inform_values: "Inform values",
        limit_by_values: "Limit by values", 
        limit_time_range: "Limit time range",
        more_than: "more than",
        not_accepted: "Not accepted",
        period_label: "Period",
        purchase_quantity: "Purchase quantity",
        purchases: "Purchases",
        search_combined_info: "Search combined info",
        search_event: "Search event",
        select_values: "Select values",
        until: "until",
        which_brand: "Which brand",
        which_category: "Which category",
        which_event: "Which event",
        which_product: "Which product",
        which_status_to_execute: "Which status to execute",
        order_custom_fields: "Order custom fields",
        op_starts_with: "Starts with",
        op_date_on: "On",
        op_date_after: "After",
        op_date_before: "Before",
        select_operator: "Select operator",
        select_date: "Select date",
        enter_value: "Enter value",
        add_custom_field: "Add custom field...",
        no_custom_fields_added: "No custom fields added yet.",
        remove_custom_field: "Remove field",
    },
};
